import Blockly from "blockly";
import Schema from "../schema";

export const menu = {
  name: (<div className="text"><u>V</u>isual Effects</div>),
  trigger: 'v',
  children: {
    'game_beer_goggles': {
      name: (<div className="text">Beer <u>G</u>oggles</div>),
      trigger: 'g',
    },
    'game_blur': {
      name: (<div className="text"><u>B</u>lur</div>),
      trigger: 'b',
    },
    'game_blackout': {
      name: (<div className="text">Blac<u>k</u> Out</div>),
      trigger: 'k',
    },
    'game_broken_lcd': {
      name: (<div className="text">Broken <u>L</u>CD</div>),
      trigger: 'l',
    },
    'game_crosshatch': {
      name: (<div className="text"><u>C</u>rosshatch</div>),
      trigger: 'c',
    },
    'game_emboss': {
      name: (<div className="text"><u>E</u>mboss</div>),
      trigger: 'e',
    },
    'game_flip_horizontally': {
      name: (<div className="text">Flip Hori<u>z</u>ontally</div>),
      trigger: 'z',
    },
    'game_flip_vertically': {
      name: (<div className="text"><u>F</u>lip Vertically</div>),
      trigger: 'f',
    },
    'game_hallucinate': {
      name: (<div className="text"><u>H</u>allucinate</div>),
      trigger: 'h',
    },
    'game_invert': {
      name: (<div className="text"><u>I</u>nvert</div>),
      trigger: 'i',
    },
    'game_neon': {
      name: (<div className="text"><u>N</u>eon</div>),
      trigger: 'n',
    },
    'game_night_vision': {
      name: (<div className="text">Night <u>V</u>ision</div>),
      trigger: 'v',
    },
    'game_pixelate': {
      name: (<div className="text">Pi<u>x</u>elate</div>),
      trigger: 'x',
    },
    'game_pop_art': {
      name: (<div className="text"><u>P</u>op Art</div>),
      trigger: 'p',
    },
    'game_sepia': {
      name: (<div className="text"><u>S</u>epia</div>),
      trigger: 's',
    },
    'game_solarize': {
      name: (<div className="text">S<u>o</u>larize</div>),
      trigger: 'o',
    },
    'game_text_adventure': {
      name: (<div className="text"><u>T</u>ext Adventure</div>),
      trigger: 't',
    },
    'game_voronoi': {
      name: (<div className="text">Vo<u>r</u>onoi</div>),
      trigger: 'r',
    },
  }
}

/* ****************************************************************************************************************
 * Beer Goggles
 *
 * Activate the Beer Goggles shader for the specified amount of time.
 ******************************************************************************************************************/
Blockly.Blocks['game_beer_goggles'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Show Beer Goggles for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds');

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Activate the Beer Goggles visual effect for the specified amount of time.');
  }
};

Blockly.JSON['game_beer_goggles'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'game_beer_goggles',
      params
    }
  } else return;
};

Schema.registerAction('game_beer_goggles', {
  "if": {
    "properties": {
      "action": {
        "const": "game_beer_goggles"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "duration": {
            "type": "number",
          },
          "from_param": {
            "type": "string",
          },
        },
        "oneOf": [
          {
            "required": [
              "duration",
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ],
  }
});

/* ****************************************************************************************************************
 * Black Out
 *
 * Activate the Black Out shader for the specified amount of time.
 ******************************************************************************************************************/
Blockly.Blocks['game_blackout'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Show Black Out for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds');

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Activate the Black Out visual effect for the specified amount of time.');
  }
};

Blockly.JSON['game_blackout'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'game_blackout',
      params
    }
  } else return;
};

Schema.registerAction('game_blackout', {
  "if": {
    "properties": {
      "action": {
        "const": "game_blackout"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "duration": {
            "type": "number",
          },
          "from_param": {
            "type": "string",
          },
        },
        "oneOf": [
          {
            "required": [
              "duration",
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ],
  }
});

/* ****************************************************************************************************************
 * Blur
 *
 * Activate the Blur shader for the specified amount of time.
 ******************************************************************************************************************/
Blockly.Blocks['game_blur'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Show Blur for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds');

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Activate the Blur visual effect for the specified amount of time.');
  }
};

Blockly.JSON['game_blur'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'game_blur',
      params
    }
  } else return;
};

Schema.registerAction('game_blur', {
  "if": {
    "properties": {
      "action": {
        "const": "game_blur"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "duration": {
            "type": "number",
          },
          "from_param": {
            "type": "string",
          },
        },
        "oneOf": [
          {
            "required": [
              "duration",
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ],
  }
});

/* ****************************************************************************************************************
 * Broken LCD
 *
 * Activate the Broken LCD shader for the specified amount of time.
 ******************************************************************************************************************/
Blockly.Blocks['game_broken_lcd'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Show Broken LCD for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds');

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Activate the Broken LCD visual effect for the specified amount of time.');
  }
};

Blockly.JSON['game_broken_lcd'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'game_broken_lcd',
      params
    }
  } else return;
};

Schema.registerAction('game_broken_lcd', {
  "if": {
    "properties": {
      "action": {
        "const": "game_broken_lcd"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "duration": {
            "type": "number",
          },
          "from_param": {
            "type": "string",
          },
        },
        "oneOf": [
          {
            "required": [
              "duration",
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ],
  }
});

/* ****************************************************************************************************************
 * Crosshatch
 *
 * Activate the Crosshatch shader for the specified amount of time.
 ******************************************************************************************************************/
Blockly.Blocks['game_crosshatch'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Show Crosshatch for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds');

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Activate the Crosshatch visual effect for the specified amount of time.');
  }
};

Blockly.JSON['game_crosshatch'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'game_crosshatch',
      params
    }
  } else return;
};

Schema.registerAction('game_crosshatch', {
  "if": {
    "properties": {
      "action": {
        "const": "game_crosshatch"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "duration": {
            "type": "number",
          },
          "from_param": {
            "type": "string",
          },
        },
        "oneOf": [
          {
            "required": [
              "duration",
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ],
  }
});

/* ****************************************************************************************************************
 * Emboss
 *
 * Activate the Emboss shader for the specified amount of time.
 ******************************************************************************************************************/
Blockly.Blocks['game_emboss'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Show Emboss for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds');

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Activate the Emboss visual effect for the specified amount of time.');
  }
};

Blockly.JSON['game_emboss'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'game_emboss',
      params
    }
  } else return;
};

Schema.registerAction('game_emboss', {
  "if": {
    "properties": {
      "action": {
        "const": "game_emboss"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "duration": {
            "type": "number",
          },
          "from_param": {
            "type": "string",
          },
        },
        "oneOf": [
          {
            "required": [
              "duration",
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ],
  }
});

/* ****************************************************************************************************************
 * Flip Horinzontally
 *
 * Activate the Flip Horizontally shader for the specified amount of time.
 ******************************************************************************************************************/
Blockly.Blocks['game_flip_horizontally'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Show Flip Horizontally for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds');

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Activate the Flip Horizontally visual effect for the specified amount of time.');
  }
};

Blockly.JSON['game_flip_horizontally'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'game_flip_horizontally',
      params
    }
  } else return;
};

Schema.registerAction('game_flip_horizontally', {
  "if": {
    "properties": {
      "action": {
        "const": "game_flip_horizontally"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "duration": {
            "type": "number",
          },
          "from_param": {
            "type": "string",
          },
        },
        "oneOf": [
          {
            "required": [
              "duration",
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ],
  }
});

/* ****************************************************************************************************************
 * Flip Vertically
 *
 * Activate the Flip Vertically shader for the specified amount of time.
 ******************************************************************************************************************/
Blockly.Blocks['game_flip_vertically'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Show Flip Vertically for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds');

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Activate the Flip Vertically visual effect for the specified amount of time.');
  }
};

Blockly.JSON['game_flip_vertically'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'game_flip_vertically',
      params
    }
  } else return;
};

Schema.registerAction('game_flip_vertically', {
  "if": {
    "properties": {
      "action": {
        "const": "game_flip_vertically"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "duration": {
            "type": "number",
          },
          "from_param": {
            "type": "string",
          },
        },
        "oneOf": [
          {
            "required": [
              "duration",
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ],
  }
});

/* ****************************************************************************************************************
 * Hallucinate
 *
 * Hallucinate for the specified amount of time.
 ******************************************************************************************************************/
Blockly.Blocks['game_hallucinate'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Show a hallucination for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds');

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Play the Delirium hallucination animation for the specified amount of time.');
  }
};

Blockly.JSON['game_hallucinate'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'game_hallucinate',
      params
    }
  } else return;
};

Schema.registerAction('game_hallucinate', {
  "if": {
    "properties": {
      "action": {
        "const": "game_hallucinate"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "duration": {
            "type": "number",
          },
          "from_param": {
            "type": "string",
          },
        },
        "oneOf": [
          {
            "required": [
              "duration",
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ],
  }
});

/* ****************************************************************************************************************
 * Invert
 *
 * Activate the Invert shader for the specified amount of time.
 ******************************************************************************************************************/
Blockly.Blocks['game_invert'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Show Invert for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds');

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Activate the Invert visual effect for the specified amount of time.');
  }
};

Blockly.JSON['game_invert'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'game_invert',
      params
    }
  } else return;
};

Schema.registerAction('game_invert', {
  "if": {
    "properties": {
      "action": {
        "const": "game_invert"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "duration": {
            "type": "number",
          },
          "from_param": {
            "type": "string",
          },
        },
        "oneOf": [
          {
            "required": [
              "duration",
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ],
  }
});

/* ****************************************************************************************************************
 * Neon
 *
 * Activate the Neon shader for the specified amount of time.
 ******************************************************************************************************************/
Blockly.Blocks['game_neon'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Show Neon for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds');

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Activate the Neon visual effect for the specified amount of time.');
  }
};

Blockly.JSON['game_neon'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'game_neon',
      params
    }
  } else return;
};

Schema.registerAction('game_neon', {
  "if": {
    "properties": {
      "action": {
        "const": "game_neon"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "duration": {
            "type": "number",
          },
          "from_param": {
            "type": "string",
          },
        },
        "oneOf": [
          {
            "required": [
              "duration",
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ],
  }
});

/* ****************************************************************************************************************
 * Night Vision
 *
 * Activate the Night Vision shader for the specified amount of time.
 ******************************************************************************************************************/
Blockly.Blocks['game_night_vision'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Show Night Vision for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds');

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Activate the Night Vision visual effect for the specified amount of time.');
  }
};

Blockly.JSON['game_night_vision'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'game_night_vision',
      params
    }
  } else return;
};

Schema.registerAction('game_night_vision', {
  "if": {
    "properties": {
      "action": {
        "const": "game_night_vision"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "duration": {
            "type": "number",
          },
          "from_param": {
            "type": "string",
          },
        },
        "oneOf": [
          {
            "required": [
              "duration",
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ],
  }
});

/* ****************************************************************************************************************
 * Pixelate the screen
 *
 * Pixelate the screen for the specified amount of time.
 ******************************************************************************************************************/
Blockly.Blocks['game_pixelate'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Pixelate the game for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds');

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Pixelate the game screen (like the Retro Vision pill) for the specified amount of time.');
  }
};

Blockly.JSON['game_pixelate'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'game_pixelate',
      params
    }
  } else return;
};

Schema.registerAction('game_pixelate', {
  "if": {
    "properties": {
      "action": {
        "const": "game_pixelate"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "duration": {
            "type": "number",
          },
          "from_param": {
            "type": "string",
          },
        },
        "oneOf": [
          {
            "required": [
              "duration",
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ],
  }
});

/* ****************************************************************************************************************
 * PopArt
 *
 * Activate the PopArt shader for the specified amount of time.
 ******************************************************************************************************************/
Blockly.Blocks['game_pop_art'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Show PopArt for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds');

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Activate the PopArt visual effect for the specified amount of time.');
  }
};

Blockly.JSON['game_pop_art'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'game_pop_art',
      params
    }
  } else return;
};

Schema.registerAction('game_pop_art', {
  "if": {
    "properties": {
      "action": {
        "const": "game_pop_art"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "duration": {
            "type": "number",
          },
          "from_param": {
            "type": "string",
          },
        },
        "oneOf": [
          {
            "required": [
              "duration",
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ],
  }
});

/* ****************************************************************************************************************
 * Sepia
 *
 * Activate the Sepia shader for the specified amount of time.
 ******************************************************************************************************************/
Blockly.Blocks['game_sepia'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Show Sepia for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds');

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Activate the Sepia visual effect for the specified amount of time.');
  }
};

Blockly.JSON['game_sepia'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'game_sepia',
      params
    }
  } else return;
};

Schema.registerAction('game_sepia', {
  "if": {
    "properties": {
      "action": {
        "const": "game_sepia"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "duration": {
            "type": "number",
          },
          "from_param": {
            "type": "string",
          },
        },
        "oneOf": [
          {
            "required": [
              "duration",
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ],
  }
});

/* ****************************************************************************************************************
 * Solarize
 *
 * Activate the Solarize shader for the specified amount of time.
 ******************************************************************************************************************/
Blockly.Blocks['game_solarize'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Show Solarize for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds');

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Activate the Solarize visual effect for the specified amount of time.');
  }
};

Blockly.JSON['game_solarize'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'game_solarize',
      params
    }
  } else return;
};

Schema.registerAction('game_solarize', {
  "if": {
    "properties": {
      "action": {
        "const": "game_solarize"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "duration": {
            "type": "number",
          },
          "from_param": {
            "type": "string",
          },
        },
        "oneOf": [
          {
            "required": [
              "duration",
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ],
  }
});

/* ****************************************************************************************************************
 * Text Adventure
 *
 * Activate the Text Adventure shader for the specified amount of time.
 ******************************************************************************************************************/
Blockly.Blocks['game_text_adventure'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Show Text Adventure for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds');

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Activate the Text Adventure visual effect for the specified amount of time.');
  }
};

Blockly.JSON['game_text_adventure'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'game_text_adventure',
      params
    }
  } else return;
};

Schema.registerAction('game_text_adventure', {
  "if": {
    "properties": {
      "action": {
        "const": "game_text_adventure"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "duration": {
            "type": "number",
          },
          "from_param": {
            "type": "string",
          },
        },
        "oneOf": [
          {
            "required": [
              "duration",
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ],
  }
});

/* ****************************************************************************************************************
 * Voronoi
 *
 * Activate the Voronoi shader for the specified amount of time.
 ******************************************************************************************************************/
Blockly.Blocks['game_voronoi'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Show Voronoi for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds');

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Activate the Voronoi visual effect for the specified amount of time.');
  }
};

Blockly.JSON['game_voronoi'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'game_voronoi',
      params
    }
  } else return;
};

Schema.registerAction('game_voronoi', {
  "if": {
    "properties": {
      "action": {
        "const": "game_voronoi"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "duration": {
            "type": "number",
          },
          "from_param": {
            "type": "string",
          },
        },
        "oneOf": [
          {
            "required": [
              "duration",
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ],
  }
});


